import { ref } from 'vue';
import axiosBaseClient from '@/axios/axiosBaseClient';

export function usePortKlaipeda() {
  const isLoading = ref(false);
  async function getData(vin: string) {
    const { data } = await axiosBaseClient.get(`/photos/${vin}`);
    isLoading.value = false;

    return data;
  }

  return {
    getData,
    isLoading,
  };
}
